module.exports = __webpack_public_path__ + "static/img/bhcmzzjd_2.b2f46ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customer/bhcmzzjd_2.jpg
// module id = PoE2
// module chunks = 15